import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { ConfirmComponent } from './confirm.component';
import { CoreModule, LazyloadService } from '@dm/core';
import { AccordionModule, TabViewModule, GrowlModule } from '@dm/ang';
import { SpecifyStrService } from '../specify-obj/specify-str.service';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';



@NgModule({
    declarations: [ConfirmComponent],
    exports: [ConfirmComponent],
    imports: [
        CommonModule,
        CoreModule,
        AccordionModule,
        TabViewModule,
        GrowlModule,
        ReactiveFormsModule,
        FormsModule,
    ],
    providers: [
        LazyloadService,
        SpecifyStrService,
    ],
})

export class ConfirmModule { }

